import type { ReactNode } from "react";
import * as styles from "./RowName.css.js";

// A row's name, plus its description (if any) in muted text beside it — wrapping onto
// its own line below the name when there isn't room to the right. `description` is the
// item's user-facing notes field, edited via the composer's "note or description"
// textarea — distinct from the separate, currently-unedited `notes` field on the entity.
export const RowName = ({ name, description }: { name: string; description: string | undefined }): ReactNode => (
  <span className={styles.wrapper}>
    <span className={styles.name}>{name}</span>
    {description !== undefined && description.trim() !== "" && <span className={styles.description}>{description}</span>}
  </span>
);
